import React from 'react';

const Profile = () => <div>Profile Page</div>;

export default Profile; 